import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import useSWRImmutable from 'swr/immutable';
import { toast } from 'react-toastify';
// eslint-disable-next-line import/no-extraneous-dependencies
import useSWR from 'swr';

import axios from '../../admin-axios';
import { ReactComponent as ArrowDown } from '../../assets/Images/arrow_down.svg';
import { ReactComponent as ArrowUp } from '../../assets/Images/arrow_up.svg';
import { ReactComponent as CallIcon } from '../../assets/Images/call_icon.svg';
import { ReactComponent as ClearedIcon } from '../../assets/Images/cleared_icon.svg';
import { ReactComponent as CustomerIcon } from '../../assets/Images/customer_icon.svg';
import { ReactComponent as EmailIcon } from '../../assets/Images/email_icon.svg';
import useActions from '../../hooks/useActions';
import { convertTons, detectError, nFormatter, numberWithCommas } from '../../utils';
import LongPaginationHandler from '../LongPaginationHandler';
import classes from './index.module.scss';

const fetcher = (url) => axios.get(url).then((res) => res.data);

const CustomersView = () => {
  const { id } = useParams();
  // const [customer, setCustomers] = useState();
  // const [loadingCustomer, setLoadingCustomer] = useState(false);
  const [arrowState, setArrowState] = useState(false);
  const [page, setPage] = useState(1);
  const [showSuccess, setShowSuccess] = useState(false);
  const [loadingWallet, setLoadingWallet] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [tableView, setTableView] = useState('normal');
  const [filterResult, setFilterResult] = useState([]);
  const [filterLoading, setFilterLoading] = useState(false);
  const [filterPage, setFilterPage] = useState(1);
  const [filterTotal, setFilterTotal] = useState(0);
  const [filterPerPage, setFilterPerPage] = useState(20);
  const [filterError, setFilterError] = useState('');
  // const [tableView, setTableView] = useState('normal');
  // const [filterResult, setFilterResult] = useState([]);
  const amountRef = useRef(null);
  const bankRef = useRef(null);
  const dateRef = useRef(null);
  const { setSubHeader } = useActions();
  const {
    user: { stationId, id: userId }
  } = useSelector((state) => state.auth);

  const {
    data: customer,
    error,
    isLoading: loadingCustomer,
    mutate
  } = useSWRImmutable(`/customer/details/${id}/${stationId}?page=${page}`, fetcher, {
    refreshInterval: 5000
  });

  const paginate = (pageNumber) => {
    setPage(pageNumber);
  };

  const paginateFilter = (pageNumber) => {
    setFilterPage(pageNumber);
  };

  const filterByDateHandler = async () => {
    if (!dateRef.current.value) {
      toast.error('Please choose a date to filter by');
      return;
    }
    const toSend = {
      date: dateRef.current.value
    };

    try {
      setFilterLoading(true);
      setTableView('filtering');
      const res = await axios.post(`customer/details/filter/${id}/${stationId}`, toSend);
      setFilterResult(res.data.purchase_history.data);
      setFilterPage(res.data.purchase_history.current_page);
      setFilterTotal(res.data.purchase_history.total);
      setFilterPerPage(res.data.purchase_history.per_page);
      setFilterLoading(false);
    } catch (e) {
      setFilterError(detectError(e));
      setFilterLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      setSubHeader('');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (filterPage && dateRef.current?.value) {
      filterByDateHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterPage]);

  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const addToWalletHandler = async () => {
    if (!amountRef.current.value) {
      toast.error('Please enter amount');
      return;
    }
    if (!paymentMethod) {
      toast.error('Please select payment method');
      return;
    }
    if (paymentMethod === 'transfer' && !bankRef.current.value) {
      toast.error('Please enter bank name');
      return;
    }
    const toSend = {
      customer_id: id,
      amount: amountRef.current.value,
      payment_method: paymentMethod,
      bank_name: bankRef?.current?.value ? bankRef?.current?.value : '',
      user_id: userId
    };
    try {
      setLoadingWallet(true);
      await axios.post('/wallet/balance/add', toSend);
      toast.success('Amount successfully added to wallet');
      setLoadingWallet(false);
      mutate();
    } catch (e) {
      toast.error(detectError(e));
      setLoadingWallet(false);
    }

    setShowSuccess(false);
  };

  // useEffect(() => {
  //   const fetchCustomer = async () => {
  //     try {
  //       setLoadingCustomer(true);
  //       const response = await axios.get(`/customer/details/${id}/${stationId}?page=${page}`);
  //
  //       setCustomers(response.data);
  //
  //       setLoadingCustomer(false);
  //     } catch (e) {
  //       setLoadingCustomer(false);
  //     }
  //   };
  //   fetchCustomer();
  // }, [id, page, stationId]);

  return (
    <>
      {error && (
        <div className="d-flex justify-content-center w-100 mb-3">
          <p className="bg-danger fs-4 fw-bold p-3">{detectError(error)}</p>
        </div>
      )}
      <div>
        {loadingCustomer && (
          <div className="d-flex justify-content-center w-100">
            <Spinner className="spinner" animation="border" variant="dark" />
          </div>
        )}
        {customer && (
          <div className={classes.customer_view}>
            <div className="row g-3 mb-5">
              <div className="col-sm-4 col-lg-3">
                <div className="d-flex justify-content-between w-100 h-100">
                  <div className={classes.customer_view_name}>
                    {customer &&
                      `${customer.customer_info.firstname} ${customer.customer_info.lastname}`}
                  </div>
                  <div className={classes.customer_view_more_details}>
                    <button
                      onClick={() => {
                        setArrowState((value) => !value);
                      }}
                      type="button"
                      className="btn">
                      <span>{arrowState ? <ArrowUp /> : <ArrowDown />}</span>
                    </button>
                    {arrowState ? (
                      <div className={`${classes.customer_view_more_details_box}`}>
                        <div className="d-flex m-2">
                          <CustomerIcon
                            className={`me-3 ${classes.customer_view_more_details_box_icon}`}
                          />
                          <div>
                            <div className="">Customer ID</div>
                            <div>{customer && customer.customer_info.customer_no}</div>
                          </div>
                        </div>
                        <div className="d-flex m-2">
                          <CallIcon
                            className={`me-3 ${classes.customer_view_more_details_box_icon}`}
                          />
                          <div>
                            <div className="">Phone Number</div>
                            <div>{customer && customer.customer_info.phone}</div>
                          </div>
                        </div>
                        <div className="d-flex m-2">
                          <EmailIcon
                            className={`me-3 ${classes.customer_view_more_details_box_icon}`}
                          />
                          <div>
                            <div className="">Email</div>
                            <div className="">{customer && customer.customer_info.email}</div>
                          </div>
                        </div>
                        <div className="d-flex m-2">
                          <ClearedIcon
                            className={`me-3 ${classes.customer_view_more_details_box_icon}`}
                          />
                          <div>
                            <div className="">Date Registered</div>
                            <div>
                              {customer &&
                                new Date(customer.customer_info.date_registered).toDateString()}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="row g-3 mb-5">
              <div className="col-xl-6">
                <div className={`${classes.customer_view_customer_balance} p-3`}>
                  <p className="text-center mb-3">Credit Balance:</p>
                  <p className="fs-2 text-center mb-5">
                    {customer && customer.currency}{' '}
                    {customer && numberWithCommas(customer.credit_balance)}
                  </p>
                  <div className="text-center">
                    <button
                      type="button"
                      onClick={() => setShowSuccess(true)}
                      className={`${classes.customer_view_customer_balance_button} btn py-2 px-4`}>
                      Add Payment
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className={classes.customer_view_customer_purchase}>
                  <div className="row g-5">
                    <div className="col-sm-6">
                      <div>
                        <div className={classes.customer_view_customer_purchase_title}>
                          {customer && convertTons(customer.total_gas_purchased)}
                        </div>
                        <div className={classes.customer_view_customer_purchase_text}>
                          Total Gas Quantity Purchased
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div>
                        <div className={classes.customer_view_customer_purchase_title}>
                          {customer && customer.currency}{' '}
                          {customer && nFormatter(customer.total_amount, 2)}
                        </div>
                        <div className={classes.customer_view_customer_purchase_text}>
                          Total Amount
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className={classes.customer_view_customer_purchase_box}>
                        <div className={classes.customer_view_customer_purchase_title}>
                          {customer && customer.currency}{' '}
                          {customer && nFormatter(customer.total_amount_paid, 2)}
                        </div>
                        <div className={classes.customer_view_customer_purchase_text}>
                          Total Amount Paid
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className={classes.customer_view_customer_purchase_box}>
                        <div
                          className={`${classes.customer_view_customer_purchase_title} text-danger`}>
                          {customer && customer.currency}{' '}
                          {customer && customer.outstanding_debt
                            ? nFormatter(Math.abs(customer.outstanding_debt), 2)
                            : 0}
                        </div>
                        <div className={classes.customer_view_customer_purchase_text}>
                          Outstanding Debt
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-lg-flex justify-content-sm-between mb-3">
              <div className="d-flex">
                <h5 className={`${classes.customer_view_transactions_header} me-3 pt-2`}>
                  Purchase History
                </h5>
                <div className={`${classes.customer_view_transactions_filter} d-sm-flex`}>
                  <input
                    type="date"
                    name="filter_date"
                    ref={dateRef}
                    placeholder="Choose Filter Date"
                    className={`form-control me-3 ${classes.customer_view_transactions_filter_input}`}
                  />
                  <button
                    onClick={filterByDateHandler}
                    className={`btn ${classes.customer_view_transactions_filter_button}`}
                    type="button">
                    Apply Filter
                  </button>
                </div>
              </div>
              <div>
                <Link
                  to={`statement/${id}/${customer.customer_info.firstname}/${customer.customer_info.lastname}`}
                  className={`btn ${classes.customer_view_transactions_filter_account_stmt_button} p-3`}>
                  Account Statement
                </Link>
              </div>
            </div>
            {tableView === 'filtering' && (
              <div className="">
                <button
                  onClick={() => setTableView('normal')}
                  type="button"
                  className="mb-3 btn unapproved_transactions_general_button">
                  Back to All History
                </button>
              </div>
            )}
            <div className={classes.customer_view_transactions_table}>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Transaction ID</th>
                    <th scope="col">Date</th>
                    <th scope="col">Gas Quantity Purchased</th>
                    <th scope="col">Price/Kg</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                {tableView === 'normal' && (
                  <tbody>
                    {customer && customer?.purchase_history?.data.length > 0 ? (
                      customer?.purchase_history?.data.map((tx) => {
                        return (
                          <tr key={tx.transaction_id}>
                            <td>{tx.transaction_id}</td>
                            <td>{tx.date_created}</td>
                            <td>{tx.gas_quantity} Kg</td>
                            <td>
                              {customer?.currency} {tx.gas_price}
                            </td>
                            <td>
                              {customer?.currency} {tx.amount}
                            </td>
                            <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>
                              {tx.status}
                            </td>
                            <td>
                              <Link
                                to={`/approved/${tx.transaction_id}`}
                                className={`btn ${classes.customer_view_transactions_table_button}`}>
                                View
                              </Link>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={7} className="w-100 text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
                {tableView === 'filtering' && (
                  <tbody>
                    {filterLoading && (
                      <tr className="py-3">
                        <td colSpan={7}>
                          <div className="d-flex justify-content-center w-100">
                            <Spinner className="spinner" animation="border" variant="dark" />
                          </div>
                        </td>
                      </tr>
                    )}
                    {filterError && (
                      <tr className="py-3">
                        <td colSpan={7}>
                          <div className="d-flex justify-content-center w-100">
                            {detectError(filterError)}
                          </div>
                        </td>
                      </tr>
                    )}
                    {!filterLoading &&
                      filterResult &&
                      filterResult.length > 0 &&
                      filterResult.map((tx) => {
                        return (
                          <tr key={tx.transaction_id}>
                            <td>{tx.transaction_id}</td>
                            <td>{tx.date_created}</td>
                            <td>{tx.gas_quantity} Kg</td>
                            <td>
                              {customer?.currency} {tx.gas_price}
                            </td>
                            <td>
                              {customer?.currency} {tx.amount}
                            </td>
                            <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>
                              {tx.status}
                            </td>
                            <td>
                              <Link
                                to={`/approved/${tx.transaction_id}`}
                                className={`btn ${classes.customer_view_transactions_table_button}`}>
                                View
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                    {!filterLoading && filterResult && filterResult.length === 0 && (
                      <tr>
                        <td colSpan={7} className="w-100 text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>
            {tableView === 'normal' && (
              <LongPaginationHandler
                elementsPerPage={customer?.purchase_history?.per_page || 20}
                totalElements={customer?.purchase_history?.total || 0}
                activePage={page}
                paginate={paginate}
              />
            )}
            {tableView === 'filtering' && (
              <LongPaginationHandler
                elementsPerPage={filterPerPage || 20}
                totalElements={filterTotal || 0}
                activePage={filterPage}
                paginate={paginateFilter}
              />
            )}
          </div>
        )}
      </div>
      <div className="customer_modals">
        <Modal
          size="lg"
          show={showSuccess}
          onHide={() => setShowSuccess(false)}
          centered
          aria-labelledby="example-modal-sizes-title-sm">
          <Modal.Header closeButton>
            <Modal.Title>Add To Wallet</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="p-1">
              <div className="row">
                <div className="col-4">
                  <div>
                    <p>Payment Method</p>
                    <select
                      className="form-select"
                      value={paymentMethod}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      aria-label="Default select example">
                      <option>Select Payment Method</option>
                      <option value="cash">Cash</option>
                      <option value="transfer">Transfer</option>
                      <option value="pos">P O S</option>
                    </select>
                  </div>
                </div>
                <div className={`col-${paymentMethod === 'transfer' ? 4 : 8}`}>
                  <div>
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="amount" className="form-label m-0">
                      Add Amount
                    </label>
                    <div className="input-group">
                      <span className="input-group-text">NGN</span>
                      <input
                        type="text"
                        ref={amountRef}
                        className="form-control"
                        id="amount"
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                </div>
                {paymentMethod === 'transfer' && (
                  <div className="col-4">
                    <div>
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="bank" className="form-label m-0">
                        Bank Name
                      </label>
                      <input
                        type="text"
                        ref={bankRef}
                        className="form-control"
                        id="bank"
                        placeholder="Bank Name"
                      />
                    </div>
                  </div>
                )}
              </div>
              <Button
                className={`mt-3 ${classes.add_wallet_button}`}
                variant="primary"
                disabled={loadingWallet}
                onClick={addToWalletHandler}>
                Add
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default CustomersView;
